export default __webpack_public_path__ + "static/media/VotingCardC_SideA.10423057.png";